<template lang="pug">
section#membresias.memberships
    .container
        .row
            .col-12
                h2.text-center.mb-5 MEMBRESÍAS
        
        // Pestañas de membresías
        .row.justify-content-center.mb-4
            .col-12
                .membership-tabs.d-flex.justify-content-center.flex-wrap
                    button.tab-button(
                        v-for="(membership, key) in memberships"
                        :key="key"
                        @click="activeTab = key"
                        :class="{ active: activeTab === key }"
                    ) {{ membership.title }}
        
        // Contenido dinámico
        .row.justify-content-center
            .col-lg-10.col-md-11.col-12
                .membership-content
                    .membership-image.text-center
                        img.img-fluid(:src="currentMembership.image" :alt="currentMembership.title")
        
        oc-arrow(:urlRef='nextSection')
</template>

<script>
import OcArrow from '@/components/shared/Arrow.vue'

export default {
    components: {
        OcArrow
    },
    data () {
        return {
            nextSection: '#in',
            activeTab: 'anual',
            memberships: {
                anual: {
                    title: 'MEMBRESÍA ANUAL',
                    image: `${HOMEURL}img/me/anual.jpeg`
                },
                semestral: {
                    title: 'MEMBRESÍA SEMESTRAL',
                    image: `${HOMEURL}img/me/semestral.jpeg`
                },
                tetramestral: {
                    title: 'MEMBRESÍA TETRAMESTRAL',
                    image: `${HOMEURL}img/me/trimestral.jpeg`
                }
            }
        }
    },
    computed: {
        currentMembership() {
            return this.memberships[this.activeTab]
        }
    }
}
</script>

<style scoped>
.memberships {
    padding: 80px 0;
    background-color: #f8f9fa;
}

.memberships h2 {
    font-size: 2.5rem;
    font-weight: bold;
    color: #2c589c;
    margin-bottom: 3rem;
}

/* Estilos para las pestañas */
.membership-tabs {
    gap: 10px;
    margin-bottom: 30px;
}

.tab-button {
    background: white;
    border: 2px solid #2c589c;
    color: #2c589c;
    padding: 12px 24px;
    border-radius: 25px;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 160px;
}

.tab-button:hover {
    background: #2c589c;
    color: white;
    transform: translateY(-2px);
}

.tab-button.active {
    background: #2c589c;
    color: white;
    box-shadow: 0 4px 15px rgba(44, 88, 156, 0.3);
}

/* Contenido de membresía */
.membership-content {
    background: white;
    border-radius: 15px;
    padding: 30px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
}

.membership-image img {
    max-width: 100%;
    width: 100%;
    height: auto;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* Responsive */
@media (max-width: 768px) {
    .memberships {
        padding: 60px 0;
    }
    
    .memberships h2 {
        font-size: 2rem;
    }
    
    .membership-tabs {
        flex-direction: column;
        align-items: center;
        gap: 15px;
    }
    
    .tab-button {
        width: 100%;
        max-width: 280px;
    }
    
    .membership-content {
        padding: 20px 15px;
    }
}

@media (max-width: 576px) {
    .tab-button {
        font-size: 12px;
        padding: 10px 20px;
    }
    
    .membership-content {
        padding: 15px 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/Memberships.vue